import { ChatContentProps } from './type';

export const ChatContent = ({ children }: ChatContentProps) => <div className="flex min-h-0">{children}</div>;
